import React, {Component} from 'react';
import classNames from "classnames";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";

import banner from "assets/img/penpaper.png";
import * as text from './tc_text';
import profilePageStyle from "assets/jss/material-kit-react/views/profilePage.jsx";

class TCPage extends Component {
  renderUserContent() {
    return (
      <div>
        <h3>5. User Content</h3>
        <p>{text.USER_CONTENT1}</p>
        <p>{text.USER_CONTENT2}</p>
        <p>{text.USER_CONTENT3}</p>
        <ul>{text.UC_LIST.map((uc_li, i) =>
          <li key={i} style={{fontSize: 14}}>{uc_li}</li>
        )}</ul>
      </div>
    );
  }

  renderCopyRight() {
    const B = (props) => <p style={{fontWeight:'bold'}}>{props.children}</p>;
    return (
      <div>
        <h3>6. Copyright Policy</h3>
        <p>{text.COPYRIGHT1}</p>
        <p>{text.COPYRIGHT2}</p>
        <p>{text.COPYRIGHT3}</p>
        <p>{text.COPYRIGHT4}</p>
        <ul>{text.CR_LIST1.map((cr_li, i) =>
          <li key={i} style={{fontSize: 14}}>{cr_li}</li>
        )}</ul>
        <p>{text.COPYRIGHT5}</p>
        <p>{text.COPYRIGHT6}</p>
        <B>{text.COPYRIGHT7}</B>
        <p>{text.COPYRIGHT8}</p>
        <ul>{text.CR_LIST2.map((cr_li, i) =>
          <li key={i} style={{fontSize: 14}}>{cr_li}</li>
        )}</ul>
        <p>{text.COPYRIGHT9}</p>
        <p>{text.CR_ADDR1}<br/>{text.CR_ADDR2}<br/>{text.CR_ADDR3}</p>
      </div>
    );
  }

  render() {
    const {classes, history, auth, ...rest} = this.props;

    return (
      <div>
        <Header
          color="transparent"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{height: 200, color: "white"}}
          {...rest}
        />
        <Parallax small filter image={banner}>
          <div className={classes.titleContainer}>
            <h1 className={classes.tcppTitle}>Terms and Conditions</h1>
          </div>
        </Parallax>
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div>
            <div className={classes.termsContainer}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={10}>
                  <div className={classes.profile}>
                    <div className={classes.name} style={{marginTop: 75}}>
                      <div style={{textAlign: 'left'}}>
                        <h2 style={{paddingTop: 15}}>PollPals Terms and Conditions</h2>
                        <h3>1. Acceptance of Terms</h3>
                        <p>{text.ACCEPT_TERMS}</p>
                        <h3>2. Change to Terms and PollPals Services</h3>
                        <p>{text.CHANGE_TERMS}</p>
                        <h3>3. Privacy Policy</h3>
                        <p>{text.PRIVACY}</p>
                        <h3>4. No Data Mining or Resale of Data Permitted</h3>
                        <p>{text.NO_MINING1}</p>
                        <p>{text.NO_MINING2}</p>
                        {this.renderUserContent()}
                        {this.renderCopyRight()}
                        <h3>7. Compliance With Applicable Law</h3>
                        <p>{text.COMPLIANCE}</p>
                        <h3>8. Disclaimer</h3>
                        <p>{text.DISCLAIMER}</p>
                        <h3>9. Limitations on Liability</h3>
                        <p>{text.LIABILITY}</p>
                        <h3>10. Disputes</h3>
                        <p>{text.LIABILITY}</p>
                        <h3>11. Indemnity</h3>
                        <p>{text.INDEMNITY}</p>
                        <h3>12. Other</h3>
                        <p>{text.OTHER1}</p>
                        <p>{text.OTHER2}</p>
                        <p>{text.OTHER3}</p>
                        <h3>Acknowledgement</h3>
                        <p>{text.ACK}</p>
                        <h3>Miscellaneous Terms of Use</h3>
                        <p>{text.MISC}</p>
                        <h3>Arbitration</h3>
                        <p>{text.ARBITRATION}</p>
                        <h3>Contact Information</h3>
                        <p>{text.CONTACT}</p>
                      </div>
                    </div>
                  </div>
                </GridItem>
              </GridContainer>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const pageWithStyles = withStyles(profilePageStyle)(TCPage);

export default pageWithStyles;



// WEBPACK FOOTER //
// ./src/views/TC.js